import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import {
  fetchInsurancePlansByPatientId,
  addInsurancePlanByPatientId,
} from '../actions/insurance.action'
import { InsuranceData } from '@dataTypes/index'

type InsuranceState = {
  data: InsuranceData | null
  loading: boolean
  error: string | null
}

const initialState: InsuranceState = {
  data: { insurancePlans: [] },
  loading: false,
  error: null,
}

const insurancesSlice = createSlice({
  name: 'insurances',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      fetchInsurancePlansByPatientId.fulfilled,
      (state, action: PayloadAction<InsuranceData>) => {
        state.data = action.payload
        state.loading = false
      },
    )
    builder.addCase(fetchInsurancePlansByPatientId.pending, (state) => {
      state.loading = true
    })
    builder.addCase(fetchInsurancePlansByPatientId.rejected, (state) => {
      state.error = null
      state.loading = false
    })

    builder
      .addCase(addInsurancePlanByPatientId.pending, (state) => {
        state.loading = true
        state.error = null
      })

      .addCase(addInsurancePlanByPatientId.fulfilled, (state) => {
        state.loading = false
        state.error = null
      })

      .addCase(addInsurancePlanByPatientId.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })
  },
})

export default insurancesSlice.reducer
